<template>
  <div>
    <span class='text-danger'>Доступ запрещен</span>
  </div>
</template>

<script>
  export default {
    data: () => {
      return {}
    }
  }
</script>
